import React from 'react'
import { Outlet } from 'react-router-dom'
import { Container } from 'react-bootstrap';

function Auth() {
    return (
        <>
            <Container className='d-flex flex-column align-items-center'>
                <div className='mb-3'>
                    <h1>MWAN API</h1>
                </div>
                <div className='formbg auth--form'>
                    <div className='formbg--padding'>
                        <Outlet />
                    </div>
                </div>
            </Container>
        </>
    )
}

export default Auth